import { Badge } from "@/components/ui/badge";
import { checklistShortLabel } from "@/lib/contest-checklist";
import type { ContestChecklistItem } from "@/types/contest-submission";

const MAX_VISIBLE = 3;

/**
 * 부적격 사유(체크리스트 X 항목)를 노션 속성처럼 축약 뱃지로 나열.
 * X 없음 → 빈 렌더, 4개 이상 → "+n" (title 로 전체 나열).
 */
export function ContestChecklistBadges({
  checklist,
}: {
  checklist: ContestChecklistItem[] | null;
}) {
  const failed = (checklist ?? []).filter((item) => item.value === "X");
  if (failed.length === 0) {
    return <span className="text-xs text-muted-foreground">-</span>;
  }

  const visible = failed.slice(0, MAX_VISIBLE);
  const overflow = failed.slice(MAX_VISIBLE);

  return (
    <div className="flex flex-wrap items-center gap-1">
      {visible.map((item) => (
        <Badge
          key={item.key}
          variant="outline"
          className="border-rose-200 bg-rose-50 px-1.5 py-0 text-[11px] font-medium text-rose-700"
        >
          {checklistShortLabel(item.key)}
        </Badge>
      ))}
      {overflow.length > 0 && (
        <Badge
          variant="outline"
          className="border-rose-200 bg-rose-50 px-1.5 py-0 text-[11px] font-medium text-rose-700"
          title={overflow.map((item) => checklistShortLabel(item.key)).join(", ")}
        >
          +{overflow.length}
        </Badge>
      )}
    </div>
  );
}
